import EdLabel from './src/index.vue'

/* istanbul ignore next */
EdLabel.install = function (Vue) {
    Vue.component(EdLabel.name, EdLabel)
}

export default EdLabel
